import { render, staticRenderFns } from "./MinusBase.vue?vue&type=template&id=68a425d3&scoped=true&"
import script from "./MinusBase.vue?vue&type=script&lang=ts&"
export * from "./MinusBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a425d3",
  null
  
)

export default component.exports